// Assessment Styles
import styled, { keyframes } from 'styled-components'
import { Card, Checkbox, Divider, Input, Button } from 'antd'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import {
  FilterSection,
  FilterTitle,
  FilterGroup,
} from 'components/FilterStyles'

export const VideoOverlay = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background-color: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1;
  display: flex;
  flex-direction: column;
`
export const AssessmentdisplayInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`

export const AssessmentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  @media (max-width: 480px) {
    gap: 8px;
    height: 32px;
  }
`
export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 320px; /* Fixed height for better consistency */
  overflow: hidden;
  background-color: #000;
`

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const VideoControls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 8px 12px;
  color: white;
`

export const VideoInfo = styled.div`
  font-size: 10px;
  line-height: 1.3;
`

export const ControlButtons = styled.div`
  display: flex;
  align-items: center;
`

export const StopButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f44336;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #d32f2f;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`

export const RedRecordButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(237, 228, 228);
  color: #4b5563;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 500;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 10px 0;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    background-color: #f2f2f2;
    color: #a0aec0;
    cursor: not-allowed;
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }

  svg {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
`

export const AudioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; // Changed from center to flex-start
  margin: 20px 0;
  width: 100%;
`

export const AudioPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;

  audio {
    flex: 1;
    height: 40px;
  }

  ${DeleteButton} {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }
  }
`

export const RecordingControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; // Changed from center to flex-start
  width: 100%;
  gap: 15px;
`

const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  laptop: '1024px',
}

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 500px;
  max-width: 100%;
`

export const ModalCheckbox = styled.div`
text-align: center;
gap: 10px;
position: relative;
margin-top: -22px;
padding: 10px;
font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  color: #A5A5A5;

}
`

export const InstructionCard = styled.div`
  padding: 24px;
  width: 100%;
`

export const InstructionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const InstructionTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #111827;
  margin: 0;
`

export const InstructionDuration = styled.div`
  font-size: 14px;
  color: #000000;
  font-weight: 600;
  margin-right: 4px;
  align-self: center; // Center it vertically
  text-align: center; // Center text
  width: 100%; // Take full width of parent container
  margin-top: 8px; // Add space between button and text
`

export const InstructionDeadline = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6b7280;
  margin-top: 8px;
`

export const ImportantNotice = styled.div`
  display: flex;
  align-items: center;
  background-color: #eef2ff;
  border-left: 4px solid #4f46e5;
  padding: 16px;
  margin: 24px 0;
  border-radius: 4px;
`

export const NoticeIcon = styled.div`
  margin-right: 12px;
  color: #4f46e5;
`

export const NoticeText = styled.p`
  font-size: 14px;
  color: #4b5563;
  margin: 0;
  font-weight: 500;
`

export const InstructionSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #111827;
  margin: 10px 0 10px 0;
  display: flex;
  align-items: center;

  &:before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #000000;
    border-radius: 50%;
    margin-right: 8px;
  }
`

export const InstructionList = styled.ul`
  list-style-type: none;
  padding-left: 24px;
  margin: 0 0 16px;
`

export const InstructionListItem = styled.li`
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
  line-height: 1.4;

  &:before {
    content: '•';
    position: absolute;
    left: 0;
    color: #000000;
  }
`

export const ContactInfo = styled.div`
  font-size: 14px;
  color: #111827;
  font-weight: 600; // Changed from 500 to 600
  margin-top: 24px;
  margin-bottom: 16px;
  text-align: left; // Changed from center to left
`

export const TakeAssessmentButton = styled.button`
  background: ${props => (props.disabled ? '#e5e7eb' : '#4F46E5')};
  color: ${props => (props.disabled ? '#9ca3af' : 'white')};
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  position: relative;
  min-width: 140px;

  &:hover {
    background: ${props => (props.disabled ? '#e5e7eb' : '#4338CA')};

    ${props =>
    props.disabled &&
    `
      .disabled-tooltip {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(-8px);
      }
    `}
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 8px 16px;
    min-width: unset;
  }
`

export const PageContainer = styled.div`
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 80px);
  width: calc(100% - 64px);
  box-sizing: border-box;
  overflow-y: auto;
  margin: 40px 32px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: ${breakpoints.tablet}) {
    width: calc(100% - 32px);
    margin: 20px 16px;
    padding: 16px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    margin: 10px 0;
    padding: 12px;
  }
`

export const ContentWrapper = styled.div`
  padding: 20px 40px;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  min-height: 580px;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 16px 20px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 12px;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }
`

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin: 0;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    text-align: center;
  }
`

export const ShowingTextContainer = styled.div`
  flex: 0.2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e5e7eb;
  min-width: 180px;
  background: white;

  @media (max-width: ${breakpoints.tablet}) {
    border-left: none;
    border-top: 1px solid #e5e7eb;
    padding: 12px;
  }
`

export const ShowingText = styled.span`
  color: ${COLORS.TEXT_MEDIUM_EMPHASIS};
  font-size: 14px;
  white-space: nowrap;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 12px;
  }
`

export const AssessmentDetails = styled.div`
  margin-bottom: 32px;

  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`

export const AssessmentName = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
    margin-bottom: 12px;
  }
`

export const TimeLeft = styled.span`
  color: #666;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
  }
`

export const InstructionSection = styled.div`
  margin-bottom: 32px;

  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`

export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin: 0 0 16px;

  &:before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #000000; // Changed from #4F46E5 to #000000
    border-radius: 50%;
    margin-right: 8px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    margin: 0 0 12px;
  }
`

export const InstructionText = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
    line-height: 1.4;
  }
`

export const List = styled.ul`
  list-style-type: disc;
  margin: 0;
  padding-left: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    padding-left: 16px;
  }
`

export const SubList = styled.ul`
  list-style-type: circle;
  margin: 8px 0;
  padding-left: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    margin: 6px 0;
    padding-left: 16px;
  }
`

export const ListItem = styled.li`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.5;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
    margin-bottom: 6px;
    line-height: 1.4;
  }
`

export const Separator = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 32px 0;

  @media (max-width: ${breakpoints.mobile}) {
    margin: 24px 0;
  }
`

export const StartButton = styled.button`
  margin-top: 32px;
  background: ${props => (props.allChecksComplete ? '#4f46e5' : '#d1d5db')};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => (props.allChecksComplete ? 'pointer' : 'not-allowed')};
  display: block;
  transition: background-color 0.3s ease;

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 24px;
    padding: 10px 20px;
    width: 100%;
    font-size: 13px;
  }

  &:hover {
    background: ${props => (props.allChecksComplete ? '#4338ca' : '#d1d5db')};
  }

  &:disabled {
    background: #d1d5db;
    cursor: not-allowed;
    opacity: 0.7;
  }
`
export const AssessmentInfoCard = styled.div`
  padding: 28px 32px;
  border: 1px solid ${COLORS.PAGE_BORDER};
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  background: #ffffff;
  width: 100%;
  min-height: 100px;
  animation: cardFadeIn 0.25s cubic-bezier(0.4, 0, 0.2, 1) both;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  @keyframes cardFadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: ${breakpoints.tablet}) {
    padding: 20px 24px;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 16px;
    min-height: 80px;
    margin-bottom: 16px;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const SearchSection = styled(Flex)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 53px;
  margin: 0 auto 20px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: white;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    flex-direction: column;
    height: auto;
  }
`

export const SearchInput = styled(Input)`
  flex: 0.8;
  height: 100%;
  border: none;

  .ant-input {
    height: 100%;
    border: none;
    padding: 8px 16px;

    &::placeholder {
      color: ${COLORS.TEXT_LOW_EMPHASIS};
    }
  }

  .ant-input-prefix {
    margin-right: 12px;
  }
`

export const NoteSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #0052cc;
  font-size: 16px;
`

export const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
`

export const Tab = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  font-weight: ${props => (props.active ? '600' : '400')};
  color: ${props => (props.active ? '#0052CC' : '#595959')};
  position: relative;
  transition: all 0.3s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: ${props => (props.active ? '100%' : '0')};
    height: 2px;
    background-color: #0052cc;
    transition: width 0.4s ease-in-out;
  }
`

export const ContentContainer = styled.div`
  opacity: ${props => (props.visible ? 1 : 0)};
  transform: translateY(${props => (props.visible ? '0' : '10px')});
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
`

export const CompletedAssessmentCard = styled(AssessmentInfoCard)`
  padding: 24px;
`

export const CompletedInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const TimeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
`

export const DaysLeft = styled.div`
  font-size: 14px;
  color: #6b7280;
`

export const DeadlineInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const DeadlineLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
`

export const DeadlineTime = styled.div`
  font-size: 14px;
  color: #374151;
`

export const FilterCard = styled(Card)`
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 24px;
`

export const AssessmentCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`


export const NavigationSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  width: 100%;
`

export const NavigationTabs = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 3px;
  }
`

export const NavigationHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
`

export const NavigationTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
`

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
`

export const ProgressBarFill = styled.div`
  height: 100%;
  background-color: #4318ff;
  border-radius: 4px;
  width: ${props => props.progress || '0%'};
  transition: width 0.3s ease;
`

export const ProgressText = styled.div`
  font-size: 14px;
  color: #6b7280;
  display: flex;
  justify-content: space-between;
`

export const EntityTag = styled.div`
  display: inline-block;
  background-color: #e8f0fe;
  color: #0052cc;
  border: 1px solid #bedaff;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 12px;
  margin-left: 8px;
`

export const InstituteTag = styled.div`
  display: inline-block;
  background-color: #e8f0fe;
  color: #0052cc;
  border: 1px solid #bedaff;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 12px;
  margin-left: 8px;
`

export const EmptyStateMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #6b7280;
  font-size: 16px;
  line-height: 1.5;
  background: #f9fafb;
  border-radius: 8px;
  margin: 20px 0;

  @media (max-width: 768px) {
    padding: 30px 15px;
    font-size: 14px;
  }
`


export const AssessmentSubtitle = styled.div`
  font-size: 14px;
  color: #6b7280;
`

export const QuestionContainer = styled.div`
  margin-bottom: 32px;
  width: 100%;
  padding: 16px;
  background: #ffffff;
  border: 1px solid ${props => (props.unanswered ? '#ff6b6b' : 'transparent')};
  border-radius: 8px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const OptionLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  padding: 2px;
`

export const RadioInput = styled.input`
  width: 16px;
  height: 16px;
  margin-top: 2px;
  cursor: pointer;
  accent-color: #4f46e5;

  &:hover {
    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
  }
`

export const OptionText = styled.span`
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
  flex: 1;
`

export const ButtonContainer = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: flex-start;
  width: 200px;
  margin-top: 20px;
  margin-left: 24px;
  margin-bottom: 24px;
  gap: 10px;
`
export const NextButton = styled.button`
  width: 80%;
  padding: 8px 16px;
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #4338ca;
  }
`

export const AssessmentContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
  overflow-x: hidden;
  background: #ffffff;
`

export const AssessmentContent = styled.div`
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
`

export const ClearAllButton = styled.button`
  background: none;
  border: none;
  color: #ff0000;
  cursor: pointer;
  float: right;
  padding: 0;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
    color: #cc0000;
  }
`

export const FilterHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`

export const StyledDivider = styled(Divider)`
  margin: 12px 0;
  border-top: 1px solid ${COLORS.PAGE_BORDER};
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

// Update the TakeButton to be smaller
export const TakeButton = styled(Button)`
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0 16px; // Increased padding
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px; // Slightly larger font
  font-weight: 600;
  width: auto;
  height: 40px; // Increased height

  &:hover {
    background: #4338ca;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 8px 16px;
  }
`

export const BackButton = styled(Button)`
  margin-right: 0;
  width: auto;
  height: 40px; // Increased height matching TakeButton
  font-size: 16px; // Slightly larger font
  padding: 0 16px; // Increased padding
  background: #fbfaff;
  border-color: #e5e0ff;
  font-weight: 600;
  color: #3249d7;
  &:hover {
    background: #fbfaff;
    border-color: #e5e0ff;
    color: #3249d7;
  }
`

export const QuestionNumber = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
`

export const InstructionDeadlineInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 14px;
`

export const InstructionTimeLeft = styled.div`
  color: #666;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
`

export const InstructionDateTime = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 600;
`
export const InstructionDeadlineSection = styled.div`
  margin-bottom: 24px;
`

export const InstructionDeadlineLabel = styled.div`
  font-size: 12px;
  color: #999;
  font-weight: 500;
  margin-bottom: 4px;
`
export const InstructionTime = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
`
export const CompletedDate = styled.div`
  text-align: right;
  min-width: 120px;
  margin-right: 32px;
`

export const CompletedLabel = styled.div`
  font-size: 12px;
  color: ${COLORS.TEXT_LOW_EMPHASIS};
  margin-bottom: 4px;
`

export const CompletedDateTime = styled.div`
  font-size: 14px;
  color: ${COLORS.TEXT_HIGH_EMPHASIS};
`

export const WarningMessage = styled.div`
  color: #dc3545;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  width: 300px;
  margin-bottom: 5px;
`

export const Section = styled.div`
  margin-bottom: 40px;
  flex-grow: 1;
`

export const Paragraph = styled.p`
  width: 89%;
  font-size: 16px;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 24px;
`

export const QuestionInstruction = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #4b5563;
  margin: 20px 0;
  font-style: italic;
`

// export const RecordedVideo = styled.div`
//   margin-top: 16px;
//   padding: 12px;
//   background: #f5f5f5;
//   border-radius: 8px;
//   display: flex;
//   align-items: left;
//   justify-content: space-between;
//   span {
//     color: #666;
//     font-size: 14px;
//   }
// `

export const RecordedVideo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f7fa;
  padding: 10px 15px;
  border-radius: 6px;
  margin: 10px 0;
  border: 1px solid #e4e9f2;
  max-width: 250px; /* Add a max-width to make it more compact */

  span {
    font-size: 14px;
    color: #444;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 15px; /* Add margin-right to bring delete button closer */
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #f54b56;
  cursor: pointer;
  padding: 4px 8px;
`
export const Question = styled.div`
  margin-bottom: 32px;
`

export const QuestionText = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 16px;
`

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Option = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #f3f4f6;
  }
  input {
    margin-right: 12px;
  }
`
export const NavigationButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 40px;
  padding-bottom: 24px;
`
export const StyledButton = styled.button`
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
  border: 1px solid transparent;

  ${props => {
    if (props.variant === 'primary') {
      return `
        background: #3249D7;
        color: white;
        &:hover {
          background: #3a489e;
        }
      `
    } else {
      return `
        background: #FBFAFF;
        color: ${props.skip ? '#3249D7' : '#3249D7'};
        border: 1px solid #E9ECEF;
        &:hover {
          background: #fbfaff;
        }
      `
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ModalText = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 25px;
`

export const ShortListModalImg = styled.div`
  text-align: center;
  margin-bottom: 25px;
`



export const StepDivider = styled.div`
  width: 1px;
  height: 30px;
  background-color: #e5e7eb;
  margin-left: 16px;
  margin-bottom: 10px;
`




export const QuestionOverlay = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  padding: 15px 20px;
  border-radius: 8px;
  max-width: 80%;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`

export const QuestionOverlayText = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  text-align: center;
`

export const Note = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  // margin-top: 6px;
  text-align: left; // Added to ensure text alignment
  padding-left: 0; // Remove any potential padding

  &:before {
    content: '!';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: rgb(244, 239, 239);
    border-radius: 50%;
    color: rgb(213, 36, 13);
  }
`
export const RecordButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; // Changed from flex-start to center
  padding: 12px 16px; // Added horizontal padding
  gap: 12px;
  opacity: ${props => (props.disabled ? '0.5' : '1')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`


export const EntityToggleContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 16px 0;
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 16px;
    margin: 12px 0;
  }
`

export const EntityToggleButton = styled.button`
  background: ${props => (props.active ? '#4F46E5' : '#f5f5f5')};
  color: ${props => (props.active ? '#ffffff' : '#666666')};
  border: 2px solid ${props => (props.active ? '#4F46E5' : '#e0e0e0')};
  padding: 8px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Plus Jakarta Sans', sans-serif;

  &:hover {
    background: ${props => (props.active ? '#4338CA' : '#e9e9e9')};
    border-color: ${props => (props.active ? '#4338CA' : '#d0d0d0')};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 6px 16px;
    font-size: 12px;
    flex: 1;
  }
`
// Update the EntityToggleWrapper to position above tabs with proper margins
export const EntityToggleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 12px 0 16px 0; // Top margin 12px, bottom margin 16px
  padding: 0 0px;
  
  @media (max-width: 768px) {
    padding: 0 16px;
    margin: 16px 0 12px 0; // Adjusted for mobile
    justify-content: center;
  }
`
export const DiagnosisAssessmentCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  gap: 24px;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #d1d5db;
  }
`

export const DiagnosisAssessmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`

export const DiagnosisAssessmentTitle = styled.h4`
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DiagnosisAssessmentType = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`

export const DiagnosisTakeButton = styled.button`
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
  white-space: nowrap;

  &:hover {
    background: #4338ca;
  }

  &:disabled {
    background: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`



export const DiagnosisSection = styled.div`
  margin-bottom: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 24px;
  }
`

export const DiagnosisHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`

export const DiagnosisTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`
export const DiagnosisBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #4f46e5;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  position: relative;

  /* Create a wrapping block to center tooltip correctly */
  justify-content: center;

  &:hover .diagnosis-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(-8px) translateX(-50%);
  }
`

export const DiagnosisTooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-4px); /* Ensures full center align */
  background: white;
  color: #374151;
  padding: 16px 20px;
  border-radius: 8px;
  font-size: 14px;
  width: 360px;
  max-width: 90vw;
  white-space: normal;
  line-height: 1.5;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
  font-weight: 400;
  text-align: left;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 8px solid transparent;
    border-top-color: white;
  }

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 9px solid transparent;
    border-top-color: #e5e7eb;
    z-index: -1;
  }

  @media (max-width: 768px) {
    width: 320px;
    padding: 12px 16px;
    font-size: 13px;
  }
`

export const DiagnosisMessage = styled.p`
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 20px 0;
  font-weight: 400;
`

export const DiagnosisAssessmentsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`

// export const DiagnosisAssessmentCard = styled.div`
//   background: white;
//   border: 1px solid #e7eaf3;
//   border-radius: 8px;
//   padding: 20px;
//   transition: all 0.2s ease;
//   position: relative;
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 20px;

//   &:hover {
//     box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
//     border-color: #d1d5db;
//   }

//   @media (max-width: 768px) {
//     padding: 16px;
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 16px;
//   }
// `

// export const DiagnosisAssessmentInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   gap: 8px;
// `

// export const DiagnosisAssessmentTitle = styled.h4`
//   font-size: 16px;
//   font-weight: 500;
//   color: #1f2937;
//   margin: 0;
//   display: flex;
//   align-items: center;
//   gap: 8px;
// `

// export const DiagnosisAssessmentType = styled.div`
//   font-size: 14px;
//   color: #6b7280;
//   margin: 0;
// `

// export const DiagnosisTakeButton = styled.button`
//   background: #4f46e5;
//   color: white;
//   border: none;
//   border-radius: 6px;
//   padding: 10px 20px;
//   font-size: 14px;
//   font-weight: 500;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   position: relative;
//   white-space: nowrap;
//   min-width: 140px;

//   &:hover {
//     background: #4338ca;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: auto;
//   }
// `

export const RegularAssessmentsSection = styled.div`
  margin-top: 32px;
  animation: sectionFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;

  @keyframes sectionFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const RegularAssessmentsSectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 20px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
`

export const DisabledTooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-4px);
  background: white; // Add this line for pure white background
  color: rgb(18, 19, 20);
  padding: 16px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  width: 250px;
  max-width: 90vw;
  white-space: normal;
  line-height: 1.5;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid rgb(197, 194, 194);
  font-weight: 400;
  text-align: left;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 8px solid transparent;
    border-top-color: white;
  }

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 9px solid transparent;
    border-top-color: #e5e7eb;
    z-index: -1;
  }

  @media (max-width: 768px) {
    width: 320px;
    padding: 12px 16px;
    font-size: 13px;
  }
`

export const DisabledTooltipTitle = styled.div`
  font-weight: 600;
  margin-bottom: 6px;
  color: #374151;
`

export const DisabledTooltipMessage = styled.div`
  font-weight: 400;
  line-height: 1.3;
  color: #374151;
`

// Add styles for Corporate message
export const CorporateMessage = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 24px;
  margin: 24px 0;
  text-align: center;

  @media (max-width: 768px) {
    padding: 16px;
    margin: 16px 0;
  }
`

export const CorporateMessageTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #111827;
  margin: 0 0 16px 0;
`

export const CorporateMessageText = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`

export const CorporateMessageButton = styled(Button)`
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 12px;

  &:hover {
    background: #4338ca;
  }
`


// Assessment Actions Container
export const AssessmentActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 8px;
`

// Copy Link Button
export const CopyLinkButton = styled.button`
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #e5e7eb;
    border-color: #9ca3af;
  }

  &:active {
    background: #d1d5db;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.2);
  }
`
export const AssessmentHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 40px;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 20px;
  }
`
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  svg {
    height: 56px;
    width: auto;
  }
  img {
    height: 56px;
    width: auto;
    object-fit: contain;
  }
  /* Target the PluginLiveLogo component specifically */
  > * {
    display: flex;
    align-items: center;
    height: 56px;
    width: auto;
  }
  @media (max-width: 768px) {
    height: 36px;
    svg,
    img {
      height: 32px;
      width: auto;
    }
    > * {
      height: 32px;
      width: auto;
    }
  }
  @media (max-width: 480px) {
    height: 32px;
    svg,
    img {
      height: 28px;
      width: auto;
    }
    > * {
      height: 28px;
      width: auto;
    }
  }
`



export const VerticalSeparator = styled.div`
  width: 1px;
  height: 28px;
  background: #d1d5db;
  margin: 0 4px;
  flex-shrink: 0;
  @media (max-width: 768px) {
    height: 32px;
  }
  @media (max-width: 480px) {
    height: 28px;
    margin: 0 2px;
  }
`

export const AssessmentTitle = styled.h1`
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  margin: 0;
  line-height: 1.2;
  display: flex;
  align-items: center;
`

export const AssessmentTimer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #4318ff;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const FullPageOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  z-index: 999999;
  overflow: auto;
  font-family: 'Inter', sans-serif;
`

// NEW: Full-page container for assessment
export const FullPageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  position: relative;
`

// NEW: Full-page timer positioned at top-right
export const FullPageTimer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #4318ff;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

// NEW: Full-page content wrapper
export const FullPageContent = styled.div`
  flex: 1;
  padding: 90px 40px 40px; /* Increased top padding to account for fixed header */
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  @media (max-width: 640px) {
    padding: 120px 20px 40px; /* More padding for mobile due to stacked header */
  }
`

export const DisabledQuestion = styled(Question)`
  opacity: 0.5;
  pointer-events: none;
`

export const FullscreenModalOverlay = styled(ModalOverlay)`
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 9999;
`

export const FullscreenModalContent = styled(ModalContent)`
  max-width: 500px;
  padding: 30px;
  text-align: center;
`

export const FullscreenTitle = styled.h2`
  color: #4318ff;
  margin-bottom: 20px;
`

export const FullscreenDescription = styled.p`
  margin-bottom: 20px;
  line-height: 1.5;
`

export const PrimaryButton = styled(Button)`
  background-color: #4318ff;
  color: white;
  font-weight: bold;
  height: 44px;
  border-radius: 4px;
  border: none;
  padding: 0 24px;
  font-size: 16px;
  &:hover {
    background-color: #3512cc;
    color: white;
  }
`

export const InfoContainer = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  color: #4b5563;
  font-size: 14px;
  font-weight: 500;
`

export const GreenInfoContainer = styled.div`
  background-color: #edffe2;
  padding: 16px 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`

export const InfoIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: #4318ff;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  margin-right: 15px;
  flex-shrink: 0;
`

export const InfoText = styled.p`
  font-weight: 400;
  font-style: italic;
  font-size: 15px;
  line-height: 109%;
  letter-spacing: 0%;
  color: #111827;
  margin: 0;
  strong {
    font-weight: 600;
    font-style: italic;
    // font-size: 23px;
    line-height: 100%;
    letter-spacing: 0%;
  }
`

// Response-language directive for the speaking / video-response section.
// Deliberately distinct from the generic gray InfoContainer so the candidate
// instantly sees which language to answer in, with the language itself as a
// high-emphasis pill.
export const LanguageCallout = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f4f3ff;
  border: 1px solid #e2dcff;
  border-radius: 10px;
  padding: 12px 16px;
  margin: 16px 0;
  animation: languageCalloutIn 0.4s cubic-bezier(0.22, 1, 0.36, 1);

  @keyframes languageCalloutIn {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const LanguageCalloutIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #eae6ff;
  color: #4318ff;

  svg {
    width: 18px;
    height: 18px;
  }
`

export const LanguageCalloutText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #3a3550;
  line-height: 1.45;
`

export const LanguagePill = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  padding: 3px 12px;
  border-radius: 100px;
  background: #4318ff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  vertical-align: middle;
  white-space: nowrap;
`

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 30px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    left: 16px;
    top: 16px;
    width: 1px;
    height: calc(100% - 32px);
    background-color: #e5e7eb;
    z-index: 0;
  }
`

export const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  width: 100%;
  position: relative;
  z-index: 1;
`

export const StepNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: ${props => {
    if (props.completed) return '#AEFF00'
    if (props.active) return '#E2EBFF' // Changed to #E2EBFF for active step
    return '#E2EBFF' // Inactive steps also use #E2EBFF
  }};
  color: ${props => {
    if (props.completed) return '#000000'
    if (props.active) return '#4318ff' // Changed to blue text for better contrast
    return '#4318ff' // Text color for inactive steps
  }};
  border-radius: 50%;
  font-size: 14px;
  font-weight: 500;
  margin-right: 15px;
  flex-shrink: 0;
`

export const StepContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 6px;
  padding: 6px 16px;
  flex: 1;
  justify-content: flex-start;
`

export const StepText = styled.div`
  font-size: 16px;
  color: #111827;
  font-weight: 500;
  margin: 0;
  flex: 0 auto;
  margin-right: 0;
`

export const ParagraphBox = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.6;
  color: #111827;
  position: relative;
`

export const BlurredParagraphText = styled.p`
  font-size: 16px;
  color: #4b5563;
  font-weight: 500;
  background-color: #f0f0f0;
  padding: 10px 20px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`

export const BlurredParagraphOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(249, 250, 251, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  z-index: 1;
  backdrop-filter: blur(8px);
`

export const StopRecordingButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff3538;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
  height: 44px;
  gap: 8px;
  
  &:hover {
    background-color: #e02d30;
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`
export const TimerDisplay = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 13px;
  min-width: 45px;
  text-align: center;
`

export const ParagraphRecordButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4318ff;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: 160px;
  height: 40px;
  svg {
    margin-left: 8px;
    margin-right: 0;
    width: 20px;
    height: 20px;
  }
  &:hover {
    background-color: #3512cc;
  }
`

export const QuestionsPlaceholder = styled.div`
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  color: #4b5563;
  font-size: 14px;
  font-weight: 500;
`

export const RecordingSuccessMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: '#000000';
  font-size: 14px;
  margin-top: 8px;
  marginBottom: '16px',
  width: 'auto'
    svg {
    margin-right: 6px;
  }
`

export const ProgressIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 0px;
`

export const ProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  padding: 0 8px;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 16px;
    left: calc(50% + 22px);
    width: calc(100% - 44px);
    height: 4px;
    background-color: ${props => {
    // ✅ CORRECTED: Show blue only if the current step is completed.
    if (props.completed) return '#3249D7';
    return '#E2EBFF';
  }};
    z-index: 0;
  }
`;

export const StepCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  border: 2px solid;
  
  ${props => props.completed || props.active ? `
    background-color: #3249D7;
    border-color: #3249D7;
    color: white;
    
    svg {
      fill: white;
      stroke: white;
    }
  ` : `
    background-color: transparent;
    border-color: #999FAC;
    color: #999FAC;
    
    svg {
      fill: none;
      stroke: #999FAC;
    }
  `}
  
  svg {
    width: 24px;
    height: 24px;
  `


export const StepLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  margin-bottom: 6px; 
`

export const ProgressStepNumber = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
  font-weight: 500;
`

export const StepTitle = styled.div`
  font-size: 16px;
  color: ${props => (props.active ? '#3249d7' : '#111827')};
  font-weight: ${props => (props.active ? '700' : '600')};
  line-height: 1.3;
  max-width: 100%;
   margin-top: 8px;
`

export const RecordingCountdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => (props.enabled ? '#FF3538' : '#FF8385')};
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => (props.enabled ? 'pointer' : 'not-allowed')};
  transition: all 0.2s ease;
  width: 180px;
  height: 40px;
  svg {
    margin-left: 6px;
    margin-right: 0;
  }
  &:hover {
    background-color: ${props => (props.enabled ? '#e02d30' : '#FF8385')};
  }
`

const countdownPop = keyframes`
  from {
    transform: scale(1.6);
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`

export const PreRecordCountdownOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  pointer-events: none;
`

export const PreRecordCountdownLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  opacity: 0.9;
`

export const PreRecordCountdownNumber = styled.div`
  font-size: 72px;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  animation: ${countdownPop} 600ms cubic-bezier(0.16, 1, 0.3, 1);
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const SectionContentBox = styled.div`
  // background-color: #f9fafb;
  // border-radius: 8px;
  // margin-bottom: 20px;
  // font-size: 16px;
  // line-height: 1.6;
  // color: #111827;
  // position: relative;
  // width: 100%;
  // margin-left: auto;
  // margin-right: auto;
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  width: 100%;
  position: relative;
  z-index: 1;
`

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  
  img {
    max-width: 100%;
    max-height: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 16px;
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #4318FF;
    box-shadow: 0 0 0 2px rgba(67, 24, 255, 0.1);
  }
`

export const EmailContainer = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
`

export const EmailField = styled.div`
  margin-bottom: 16px;
  
  label {
    display: block;
    font-weight: 500;
    margin-bottom: 4px;
    color: #374151;
  }
  
  input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #4318FF;
      box-shadow: 0 0 0 2px rgba(67, 24, 255, 0.1);
    }
  }
`

export const DictationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const DictationItem = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  
  .sentence-number {
    font-weight: 600;
    color: #4318FF;
    margin-bottom: 12px;
  }
  
  .audio-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  
  input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #4318FF;
      box-shadow: 0 0 0 2px rgba(67, 24, 255, 0.1);
    }
  }
`

export const SentenceCompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SentenceItem = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  
  .sentence-text {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 12px;
    
    .blank {
      display: inline-block;
      width: 120px;
      height: 32px;
      border-bottom: 2px solid #4318FF;
      margin: 0 4px;
      vertical-align: bottom;
    }
  }
  
  input {
    width: 150px;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #4318FF;
      box-shadow: 0 0 0 2px rgba(67, 24, 255, 0.1);
    }
  }
`

export const SentenceBuildContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const WordBox = styled.div`
  display: inline-block;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 4px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  
  &:hover {
    background: #e5e7eb;
  }
  
  &.selected {
    background: #4318FF;
    color: white;
    border-color: #4318FF;
  }
`

export const DropZone = styled.div`
  min-height: 60px;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 16px 0;
  
  &.active {
    border-color: #4318FF;
    background: rgba(67, 24, 255, 0.05);
  }
`

export const ParagraphOrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ParagraphBlock = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  
  &:hover {
    border-color: #4318FF;
  }
  
  &.selected {
    border-color: #4318FF;
    background: rgba(67, 24, 255, 0.05);
  }
  
  .order-number {
    display: inline-block;
    background: #4318FF;
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 12px;
    margin-right: 12px;
  }
`


export const WritingContainer = styled.div`
  display: flex;
  min-height: 600px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  margin: 20px 0;
`

export const WritingSidebar = styled.div`
  width: 300px;
  background: #f9fafb;
  border-right: 1px solid #e5e7eb;
  padding: 20px;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    width: 250px;
    padding: 16px;
  }
`

export const WritingSidebarTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
`

export const WritingSubSection = styled.div`
  margin-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;
  background: ${props => props.active ? 'white' : 'transparent'};
  border: 1px solid ${props => props.active ? '#4318FF' : 'transparent'};
`

export const WritingSubSectionTitle = styled.div`
  padding: 12px 16px;
  font-weight: 500;
  color: ${props => {
    if (props.completed) return '#059669'
    if (props.active) return '#4318FF'
    return '#374151'
  }};
  background: ${props => {
    if (props.completed) return '#ecfdf5'
    if (props.active) return '#f0f4ff'
    return 'transparent'
  }};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.active ? '#f0f4ff' : '#f3f4f6'};
  }
`

export const CompletedIcon = styled.span`
  color: #059669;
  font-weight: bold;
  font-size: 16px;
`

export const WritingQuestionsList = styled.div`
  background: white;
  padding: 8px 0;
`

export const WritingQuestionItem = styled.div`
  padding: 8px 16px;
  margin: 2px 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => {
    if (props.completed) return '#ecfdf5'
    if (props.active) return '#ede9fe'
    return 'transparent'
  }};
  color: ${props => {
    if (props.completed) return '#059669'
    if (props.active) return '#4318FF'
    return '#6b7280'
  }};
  border-left: 3px solid ${props => {
    if (props.completed) return '#059669'
    if (props.active) return '#4318FF'
    return 'transparent'
  }};
  
  &:hover {
    background: ${props => props.active ? '#ede9fe' : '#f3f4f6'};
  }
`

export const WritingContent = styled.div`
  flex: 1;
  padding: 30px;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`

export const WritingNavigationButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 30px;
  justify-content: flex-end;
  
  @media (max-width: 768px) {
    justify-content: space-between;
  }
`

export const WritingProgressIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 6px;
  font-size: 14px;
  color: #64748b;
`


/////

export const QuestionBasedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 0;
`

export const QuestionBasedHeader = styled.div`
  width: 100%;
`

export const QuestionBasedTimer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.timeWarning ? '#dc2626' : '#4318ff'};
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  margin: 16px auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: fit-content;
  transition: all 0.3s ease;
  
  ${props => props.timeWarning && `
    animation: pulse 1s infinite;
  `}
  
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
`
export const QuestionBasedContent = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const QuestionBasedImageSection = styled.div`
  flex: 0 0 45%;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    flex: none;
    width: 100%;
  }
`

export const QuestionBasedImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  
  img {
    max-width: 100%;
    max-height: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    object-fit: contain;
  }
`

export const QuestionBasedTextSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const QuestionBasedQuestion = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`

export const QuestionBasedTextArea = styled.textarea`
  width: 100%;
  min-height: 300px;
  padding: 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #4318FF;
    box-shadow: 0 0 0 3px rgba(67, 24, 255, 0.1);
  }
  
  &:disabled {
    background-color: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    min-height: 250px;
  }
`

export const QuestionBasedWordCount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
`

export const QuestionBasedWarning = styled.div`
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 8px 12px;
  margin: 12px 0;
  font-size: 14px;
  color: #92400e;
  display: ${props => props.show ? 'block' : 'none'};
`

// Broadcast spec badges
export const SpecBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  background: #EEF0FF;
  color: #3249D7;
  border: 1px solid #D6DEFF;
  white-space: nowrap;
  transition: background 0.2s ease, border-color 0.2s ease;
`

export const SpecBadgeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
`

export const SectionLoadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  margin: 4px 0 16px;
  border: 1px dashed #D1D5DB;
  border-radius: 8px;
  background: #FAFAFA;
  color: #6B7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
  &:hover {
    border-color: #3249D7;
    color: #3249D7;
    background: #F5F7FF;
  }
  &:active {
    transform: scale(0.99);
  }
`

export const FilterBadgeBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 16px;
  margin-bottom: 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`

export const FilterBadge = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid ${props => props.active ? '#3249D7' : '#E5E7EB'};
  background: ${props => props.active ? '#3249D7' : '#FFFFFF'};
  color: ${props => props.active ? '#FFFFFF' : '#4B5563'};
  box-shadow: ${props => props.active ? '0 1px 3px rgba(50, 73, 215, 0.25)' : '0 1px 2px rgba(0, 0, 0, 0.04)'};
  &:hover {
    border-color: ${props => props.active ? '#2a3dbf' : '#3249D7'};
    background: ${props => props.active ? '#2a3dbf' : '#F8F9FF'};
    color: ${props => props.active ? '#FFFFFF' : '#3249D7'};
    box-shadow: 0 2px 4px rgba(50, 73, 215, 0.12);
  }
  &:active {
    transform: scale(0.97);
    transition: transform 0.1s ease;
  }
`

export const BadgeCount = styled.span`
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: ${props => props.active ? 'rgba(255, 255, 255, 0.25)' : '#F3F4F6'};
  color: ${props => props.active ? '#FFFFFF' : '#6B7280'};
`

export const MoreBadgesButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: 1px dashed #D1D5DB;
  background: #FFFFFF;
  color: #6B7280;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    border-color: #3249D7;
    border-style: solid;
    color: #3249D7;
    background: #F8F9FF;
  }
  &:active {
    transform: scale(0.97);
  }
`
export const FilteredListWrapper = styled.div`
  & > ${AssessmentInfoCard}:nth-child(1) { animation-delay: 0ms; }
  & > ${AssessmentInfoCard}:nth-child(2) { animation-delay: 40ms; }
  & > ${AssessmentInfoCard}:nth-child(3) { animation-delay: 80ms; }
  & > ${AssessmentInfoCard}:nth-child(4) { animation-delay: 120ms; }
  & > ${AssessmentInfoCard}:nth-child(5) { animation-delay: 160ms; }
  & > ${AssessmentInfoCard}:nth-child(n+6) { animation-delay: 200ms; }
`
